<template>
  <div
    class="flex flex-col gap-4 items-center justify-center"
    :class="['empty-component--' + size]"
  >
    <div class="flex flex-col items-center justify-center w-full">
      <Icon
        class="text-quaternary"
        :class="size == 'sm' ? 'text-[2rem]' : size == 'md' ? 'text-[3rem]' : 'text-[4rem]'"
        :type="icon"
      />
      <div class="max-w-96 font-medium text-center">{{ title || $t('ui.messages.noResults') }}</div>
      <div
        v-if="description"
        class="max-w-[700px] text-quaternary text-center"
      >
        {{ description }}
      </div>
    </div>

    <slot></slot>

    <slot name="buttons"></slot>
  </div>
</template>

<script setup lang="ts">
import Icon from '@/components/icon/Icon.vue'

defineProps({
  title: {
    type: String,
    default: () => ''
  },
  description: {
    type: String,
    default: null
  },
  icon: {
    type: String,
    default: 'cloud-question'
  },
  size: {
    type: String,
    default: 'lg' // sm, md, lg
  }
})
</script>

<style>
.empty-component--sm {
  font-size: var(--text-md);
  padding: var(--s-2);
}
.empty-component--md {
  font-size: var(--text-md);
  padding: var(--s-4);
}
.empty-component--lg {
  font-size: var(--text-lg);
  padding: var(--s-8);
}
</style>
